import { FastifyRequest } from 'fastify'

export enum AuthMethod {
	JWT = 'jwt',
	GoogleBookingServer = 'google_booking_server',
}

export interface AuthStrategy {
	validate(request: FastifyRequest): Promise<unknown>
}
